export default function snakeToPascal(str) {
    const camelCase = str.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('_', ''));

    return camelCase[0].toUpperCase() + camelCase.substr(1);
}